import { render, staticRenderFns } from "./recordSchoolRegistration.vue?vue&type=template&id=1abef940"
import script from "./recordSchoolRegistration.vue?vue&type=script&lang=ts"
export * from "./recordSchoolRegistration.vue?vue&type=script&lang=ts"
import style0 from "./recordSchoolRegistration.vue?vue&type=style&index=0&id=1abef940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports